module.exports = __webpack_public_path__ + "img/car_mechanic.67fc7792.png";